
import {define} from "observable:runtime";
import asset1 from "../style.css?url";

const assets = new Map([
  ["../style.css", asset1]
]);

define(
  {
    root: document.getElementById(`cell-2`),
    expanded: [],
    variables: []
  },
  {
    id: 2,
    body: async (html,display) => {
const {createUI, installHashImportBanner, installThemeToggle} = await import("../lib/helpers.js").then((module) => {
  if (!("createUI" in module)) throw new SyntaxError(`export 'createUI' not found`);
  if (!("installHashImportBanner" in module)) throw new SyntaxError(`export 'installHashImportBanner' not found`);
  if (!("installThemeToggle" in module)) throw new SyntaxError(`export 'installThemeToggle' not found`);
  return module;
});
installThemeToggle({ html, display });
installHashImportBanner({ html, display });
const { codeEditor, canvasOutput, canvasTest, canvasTestReport } = createUI({ html });
return {createUI,installHashImportBanner,installThemeToggle,codeEditor,canvasOutput,canvasTest,canvasTestReport};
},
    inputs: ["html","display"],
    outputs: ["createUI","installHashImportBanner","installThemeToggle","codeEditor","canvasOutput","canvasTest","canvasTestReport"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-5`),
    expanded: [],
    variables: []
  },
  {
    id: 5,
    body: (view,codeEditor) => {
const code_fill = view(codeEditor("canvas:rect-fill", {
  value: `// Obere linke Ecke bei (50, 100), 200 breit, 150 hoch
ctx.fillRect(50, 100, 200, 150)`
}));
return {code_fill};
},
    inputs: ["view","codeEditor"],
    outputs: ["code_fill"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-6`),
    expanded: [],
    variables: []
  },
  {
    id: 6,
    body: (display,canvasOutput,code_fill) => {
display(canvasOutput(code_fill, { width: 500, height: 320 }));
},
    inputs: ["display","canvasOutput","code_fill"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-8`),
    expanded: [],
    variables: []
  },
  {
    id: 8,
    body: (view,codeEditor) => {
const code_stroke = view(codeEditor("canvas:rect-stroke", {
  value: `ctx.strokeRect(50, 100, 200, 150)`
}));
return {code_stroke};
},
    inputs: ["view","codeEditor"],
    outputs: ["code_stroke"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-9`),
    expanded: [],
    variables: []
  },
  {
    id: 9,
    body: (display,canvasOutput,code_stroke) => {
display(canvasOutput(code_stroke, { width: 500, height: 320 }));
},
    inputs: ["display","canvasOutput","code_stroke"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-11`),
    expanded: [],
    variables: []
  },
  {
    id: 11,
    body: (view,codeEditor) => {
const code_clear = view(codeEditor("canvas:rect-clear", {
  value: `ctx.fillRect(50, 50, 200, 200)        // Großes Rechteck zeichnen
ctx.fillRect(75, 75, 150, 150)        // Zweites Rechteck darüber
ctx.clearRect(100, 100, 100, 100)     // Loch in die Mitte schneiden`
}));
return {code_clear};
},
    inputs: ["view","codeEditor"],
    outputs: ["code_clear"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-12`),
    expanded: [],
    variables: []
  },
  {
    id: 12,
    body: (display,canvasOutput,code_clear) => {
display(canvasOutput(code_clear, { width: 400, height: 320 }));
},
    inputs: ["display","canvasOutput","code_clear"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-14`),
    expanded: [],
    variables: []
  },
  {
    id: 14,
    body: (view,codeEditor) => {
const code_possize = view(codeEditor("canvas:rect-possize", {
  value: `// Position: (100, 50)  ·  Größe: 200 x 100
ctx.fillRect(100, 50, 200, 100)`
}));
return {code_possize};
},
    inputs: ["view","codeEditor"],
    outputs: ["code_possize"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-15`),
    expanded: [],
    variables: []
  },
  {
    id: 15,
    body: (display,canvasOutput,code_possize) => {
display(canvasOutput(code_possize, { width: 400, height: 220 }));
},
    inputs: ["display","canvasOutput","code_possize"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-17`),
    expanded: [],
    variables: []
  },
  {
    id: 17,
    body: (view,codeEditor) => {
const code_ex1 = view(codeEditor("canvas:rect-ex1", {
  value: `// Dein Code hier:
`
}));
return {code_ex1};
},
    inputs: ["view","codeEditor"],
    outputs: ["code_ex1"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-18`),
    expanded: [],
    variables: []
  },
  {
    id: 18,
    body: (display,canvasOutput,code_ex1) => {
display(canvasOutput(code_ex1, { width: 500, height: 440 }));
},
    inputs: ["display","canvasOutput","code_ex1"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-19`),
    expanded: [],
    variables: []
  },
  {
    id: 19,
    body: (display,canvasTestReport,canvasTest,code_ex1) => {
display(canvasTestReport(canvasTest(code_ex1, {
  width: 500, height: 440,
  checks: [
    { name: "Rechteck 400 × 300 an Position (50, 100)", run: ({ base }) => {
        const hit = base.callsTo("fillRect").some(c => {
          const [x, y, w, h] = c.args;
          return Math.abs(x - 50) <= 2 && Math.abs(y - 100) <= 2 &&
                 Math.abs(w - 400) <= 2 && Math.abs(h - 300) <= 2;
        });
        return { passed: hit };
    } }
  ]
}), "Übung 1"));
},
    inputs: ["display","canvasTestReport","canvasTest","code_ex1"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-21`),
    expanded: [],
    variables: []
  },
  {
    id: 21,
    body: (view,codeEditor) => {
const code_ex2 = view(codeEditor("canvas:rect-ex2", {
  value: `ctx.fillRect(20, 20, 120, 80)
// zwei weitere Rechtecke ...
`
}));
return {code_ex2};
},
    inputs: ["view","codeEditor"],
    outputs: ["code_ex2"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-22`),
    expanded: [],
    variables: []
  },
  {
    id: 22,
    body: (display,canvasOutput,code_ex2) => {
display(canvasOutput(code_ex2, { width: 500, height: 320 }));
},
    inputs: ["display","canvasOutput","code_ex2"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-23`),
    expanded: [],
    variables: []
  },
  {
    id: 23,
    body: (display,canvasTestReport,canvasTest,code_ex2) => {
display(canvasTestReport(canvasTest(code_ex2, {
  width: 500, height: 320,
  checks: [
    { name: "Mindestens drei Rechtecke", run: ({ base }) => {
        const n = base.callsTo("fillRect").length + base.callsTo("strokeRect").length;
        return { passed: n >= 3, detail: `${n} Rechteck-Befehle gefunden` };
    } }
  ]
}), "Übung 2"));
},
    inputs: ["display","canvasTestReport","canvasTest","code_ex2"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-25`),
    expanded: [],
    variables: []
  },
  {
    id: 25,
    body: (display,canvasOutput) => {
display(canvasOutput(`// Zielbild — 6 Befehle. Im Bild sind nur wenige Maße markiert.
ctx.strokeRect(50, 50, 300, 300)
ctx.fillRect(100, 175, 100, 100)
ctx.fillRect(150, 225, 100, 100)
ctx.clearRect(150, 225, 50, 50)
ctx.strokeRect(150, 75, 100, 100)
ctx.strokeRect(200, 125, 100, 100)

// ---- wenige Maße (rot, NICHT Teil der Lösung) ----
ctx.strokeStyle = "#dd1111"
ctx.fillStyle = "#dd1111"
ctx.lineWidth = 1
ctx.font = "13px sans-serif"
ctx.textBaseline = "middle"

function punkt(px, py) {
  ctx.beginPath()
  ctx.arc(px, py, 2.5, 0, 7)
  ctx.fill()
}

// Ecke des äußeren Rahmens
punkt(50, 50)
ctx.textAlign = "left"
ctx.fillText("(50, 50)", 58, 40)

// Größe eines kleinen Quadrats (obere Kante des oberen Umriss-Quadrats)
ctx.beginPath()
ctx.moveTo(150, 64); ctx.lineTo(250, 64)
ctx.moveTo(150, 60); ctx.lineTo(150, 68)
ctx.moveTo(250, 60); ctx.lineTo(250, 68)
ctx.stroke()
ctx.textAlign = "center"
ctx.fillText("100", 200, 53)

// Anker des oberen Umriss-Quadrats
punkt(150, 75)
ctx.textAlign = "right"
ctx.fillText("(150, 75)", 146, 87)

// Anker des oberen gefüllten Quadrats
punkt(100, 175)
ctx.textAlign = "right"
ctx.fillText("(100, 175)", 96, 187)`, { width: 400, height: 400 }));
},
    inputs: ["display","canvasOutput"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-26`),
    expanded: [],
    variables: []
  },
  {
    id: 26,
    body: (view,codeEditor) => {
const code_ex3 = view(codeEditor("canvas:rect-ex3", {
  value: `// Experimentiere hier:
`
}));
return {code_ex3};
},
    inputs: ["view","codeEditor"],
    outputs: ["code_ex3"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-27`),
    expanded: [],
    variables: []
  },
  {
    id: 27,
    body: (display,canvasOutput,code_ex3) => {
display(canvasOutput(code_ex3, { width: 400, height: 400 }));
},
    inputs: ["display","canvasOutput","code_ex3"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-28`),
    expanded: [],
    variables: []
  },
  {
    id: 28,
    body: (display,canvasTestReport,canvasTest,code_ex3) => {
const hasRect = (base, name, ex, ey, ew, eh) => base.callsTo(name).some(c => {
  const [x, y, w, h] = c.args;
  return Math.abs(x - ex) <= 2 && Math.abs(y - ey) <= 2 &&
         Math.abs(w - ew) <= 2 && Math.abs(h - eh) <= 2;
});
display(canvasTestReport(canvasTest(code_ex3, {
  width: 400, height: 400,
  checks: [
    { name: "Äußerer Rahmen `strokeRect(50, 50, 300, 300)`", run: ({ base }) => hasRect(base, "strokeRect", 50, 50, 300, 300) },
    { name: "Gefülltes Quadrat `fillRect(100, 175, 100, 100)`", run: ({ base }) => hasRect(base, "fillRect", 100, 175, 100, 100) },
    { name: "Gefülltes Quadrat `fillRect(150, 225, 100, 100)`", run: ({ base }) => hasRect(base, "fillRect", 150, 225, 100, 100) },
    { name: "Umriss-Quadrat `strokeRect(150, 75, 100, 100)`", run: ({ base }) => hasRect(base, "strokeRect", 150, 75, 100, 100) },
    { name: "Umriss-Quadrat `strokeRect(200, 125, 100, 100)`", run: ({ base }) => hasRect(base, "strokeRect", 200, 125, 100, 100) },
    { name: "Loch `clearRect(150, 225, 50, 50)`", run: ({ base }) => hasRect(base, "clearRect", 150, 225, 50, 50) },
    { name: "Das Loch ist wirklich freigestellt (Reihenfolge!)", run: ({ base }) => {
        const inHole = base.pixel(175, 250)[3];       // Mitte des Lochs → durchsichtig (Alpha 0)
        const inFill = base.pixel(120, 250);          // gefüllt, aber außerhalb des Lochs → schwarz, deckend
        const holeClear = inHole <= 20;
        const fillSolid = inFill[3] >= 235 && inFill[0] <= 20 && inFill[1] <= 20 && inFill[2] <= 20;
        return { passed: holeClear && fillSolid, detail: holeClear ? (fillSolid ? null : "die Füllung ist nicht deckend") : "im Loch ist es nicht durchsichtig" };
    } }
  ]
}), "Übung 3"));
return {hasRect};
},
    inputs: ["display","canvasTestReport","canvasTest","code_ex3"],
    outputs: ["hasRect"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
